import React from 'react'
import { StyleSheet } from 'react-native'

import { Button, H3, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { DEVICE_HEIGHT, DEVICE_WIDTH } from '@zet/utils/Constants'
import { navigateTo } from '@zet/utils/navigation'
import ConfettiAnimation from '@zet/zet-prime/assets/lottie/ConfettiAnimation.json'
import CONGRATULATION_TEXT from '@zet/zet-prime/assets/svgs/congratulationText.svg'
import Header from '@zet/zet-prime/src/components/header'
import { Image } from 'expo-image'
import LottieView from 'lottie-react-native'

export default function ZetPrimeSuccessScreen() {
  const onSellNowPress = () => {
    navigateTo('HomeView', { screen: 'Categories' })
  }
  return (
    <Stack className="bg-white flex-1">
      <LottieView
        autoPlay
        // loop={false}
        resizeMode="cover"
        style={styles.lottie}
        source={ConfettiAnimation}
      />
      <Stack className="items-center py-[100px] px-4">
        <Header showOptions={false} />
        <Image
          source={require('@zet/zet-prime/assets/images/greenTick.png')}
          contentFit="contain"
          style={styles.tickImage}
        />
        <CONGRATULATION_TEXT />
        <H3 className="text-center px-6 mt-4 font-bold">
          {i18n.t('zetPrime.yourZetPrimeIsActive')}
        </H3>
      </Stack>
      <Stack
        className="w-full bg-white p-3 position-absolute bottom-0"
        style={styles.bottomContainer}
      >
        <Button className="w-full" size="lg" onPress={onSellNowPress}>
          {i18n.t('zetPrime.sellProductsNow')}
        </Button>
      </Stack>
    </Stack>
  )
}

const styles = StyleSheet.create({
  lottie: {
    width: DEVICE_WIDTH,
    height: DEVICE_HEIGHT * 0.7,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0,
  },
  tickImage: {
    width: 96,
    height: 96,
    marginBottom: 28,
  },
  bottomContainer: {
    position: 'absolute',
    bottom: 0,
    zIndex: 10,
    shadowColor: '#0D1239',
    shadowOffset: {
      width: 0,
      height: -2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 8,
  },
})
